module.exports = __webpack_public_path__ + "static/media/mobile_first_img.04cbbfde.png";